var App = App || {};

App.VcLogin = (function ($) {
    "use strict";

    var isInvestments = Login.isInvestments;

    function init() {
        var $loginModal = new bootstrap.Modal(document.getElementById("ModalLogin")),
            $loginServices = $("select#login-services"),
            $loginInvestments = $("#login-investments"),

            $investmentLogins = $(".investment-logins"),
            $otherLogins = $(".other-logins");

        document
            .getElementById("ModalLogin")
            .addEventListener("show.bs.modal", function () {
                if ($investmentLogins.length && isInvestments == "True") {
                    $investmentLogins.show();
                    $otherLogins.hide();
                } else {
                    $investmentLogins.hide();
                    $otherLogins.show();
                }
            });

        $("a[href='#otherLogins']").on("click", function (e) {
            e.preventDefault();
            e.stopPropagation();

            $investmentLogins.slideUp();
            $otherLogins.slideDown();
        });

        $loginServices.on("change", function () {
            var $this = $(this),
                url = $this.val();

            if (url) {
                $loginModal.toggle();
                App.SiteModals.ModalSpeedbump(url);

                $loginServices.val("");
            }
        });

        $loginInvestments.on("click", function () {
            $loginModal.toggle();
        });
    }

    return {
        init: init
    };
})(jQuery);

$(function () {
    App.VcLogin.init();
});